import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TransitGroup } from '@e-origin/shared';

import { TextInput } from '@components';
import { TransitDuplicateRow } from '../../../TransitDuplicateRow';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { HouseConsignee } from './HouseConsignee';
import { HouseConsignor } from './HouseConsignor';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseStakeholdersProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  disabled: boolean;
}

export const HouseStakeholders: React.FC<HouseStakeholdersProps> = (props) => {
  const { form, houseForm, disabled } = props;
  const isArrival = form?.values?.generalInfo?.group === TransitGroup.ARRIVAL;

  return (
    <Stack mt="md">
      <HouseConsignor form={form} houseForm={houseForm} editDisabled={disabled} />
      <HouseConsignee form={form} houseForm={houseForm} editDisabled={disabled} />
      {!isArrival && (
        <Stack mb="md">
          <Title order={5} fw={600}>
            Additional supply chain actor
          </Title>

          {(form?.values?.Consignment?.AdditionalSupplyChainActor || []).map((doc, docIdx) => (
            <Grid key={docIdx}>
              <Grid.Col span={6}>
                <TextInput label="Role" value={doc.role} disabled />
              </Grid.Col>
              <Grid.Col span={6}>
                <TextInput label="Identification number" value={doc.identificationNumber} disabled />
              </Grid.Col>
            </Grid>
          ))}

          <TransitDuplicateRow
            addButtonLabel="Add"
            addButtonDataPW="add-additional-supply-chain-actor-btn"
            form={houseForm}
            inputs={[
              {
                type: 'MultiLang',
                label: 'Role',
                name: 'role',
                code: 'CL704',
                width: 49,
              },
              {
                type: 'Input',
                label: 'Identification number',
                name: 'identificationNumber',
                width: 38,
              },
            ]}
            arrayPath="AdditionalSupplyChainActor"
            disabled={props.disabled}
          />
        </Stack>
      )}
    </Stack>
  );
};
